import axiosInstance from './axiosInstance';
import { API_BASE_URL } from '../constants';
import { ApiResponse, handleRequest } from '../utils';
import { AddUser, Organisation, Plan, UpdateUser, UserResponse } from '../types';

export const OrganizationService = {
  getUsers: async (
    search?: string,
    sortBy?: string,
    sortOrder?: string,
    status?: string,
  ): Promise<ApiResponse<UserResponse>> => {
    return handleRequest<UserResponse>(async () => {
      return await axiosInstance.get(`${API_BASE_URL}/organisation/users`, {
        params: {
          search,
          sortBy,
          sortOrder,
          status,
        },
      });
    });
  },
  addUser: async (dto: AddUser): Promise<ApiResponse<AddUser>> => {
    return handleRequest<AddUser>(async () => {
      return await axiosInstance.post(`${API_BASE_URL}/organisation`, {
        ...dto,
      });
    });
  },
  updateUser: async (dto: UpdateUser): Promise<ApiResponse<UpdateUser>> => {
    return handleRequest<UpdateUser>(async () => {
      return await axiosInstance.patch(`${API_BASE_URL}/organisation/user`, {
        ...dto,
      });
    });
  },
  removeUser: async (userId: number): Promise<ApiResponse<void>> => {
    return handleRequest<void>(async () => {
      return await axiosInstance.delete(`${API_BASE_URL}/organisation/users/${userId}`);
    });
  },
  organizationPlans: async (): Promise<ApiResponse<Plan[]>> => {
    return handleRequest<Plan[]>(async () => {
      return await axiosInstance.get(`${API_BASE_URL}/organisation/plans`);
    });
  },
  organisation: async (): Promise<ApiResponse<Organisation>> => {
    return handleRequest<Organisation>(async () => {
      return await axiosInstance.get(`${API_BASE_URL}/organisation`);
    });
  },
};
